export const STAKING_FETCH_POOL_BALANCES_BEGIN = 'STAKING_FETCH_POOL_BALANCES_BEGIN';
export const STAKING_FETCH_POOL_BALANCES_SUCCESS = 'STAKING_FETCH_POOL_BALANCES_SUCCESS';
export const STAKING_FETCH_POOL_BALANCES_FAILURE = 'STAKING_FETCH_POOL_BALANCES_FAILURE';
//  fetchApproval


